module.exports = __webpack_public_path__ + "static/media/LikeButton.418bac34.svg";